import { BREAK_POINT } from 'constants/responsive';
import React from 'react';

import { imageUrlAppendStyle } from 'contexts/link_util';

import './SlideShowSlide.sass';

export interface ISlideshowSlideProps {
    title: string;
    description: string;
    img: string;
    theme: string;
    url: string;
}

const SlideShowSlide: React.StatelessComponent<ISlideshowSlideProps> = (props: ISlideshowSlideProps) => {
    const descriptionLines = props.description.split(/\r\n/g);

    const urlImageStyle = imageUrlAppendStyle(props.img, 'hero');

    const background = (theme: string) => {
        switch (theme) {
            case 'white':
                return `linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0) 65%), linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0) 15%), url(${urlImageStyle}) no-repeat center`;
            default:
                return `linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0) 65%), linear-gradient(to left, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0) 15%), url(${urlImageStyle}) no-repeat center`;
        }
    };

    return(
        <div className={`Slideshow-slide-container${window.innerWidth < BREAK_POINT ? '-mobile' : ''} theme-${props.theme}`}>
            <div
                className="Slideshow-background"
                style={{
                    background: background(props.theme),
                    backgroundSize: 'cover',
                    height: '100%',
                    width: '100%'
                }}
            />
            <div className="Text-overlay">
                <span className="Title">{props.title.toUpperCase()}</span>
                {descriptionLines.map(val => (<span key={val} className="Description">{val}</span>))}
                <span className="Link"><a href={props.url}>Read More</a></span>
            </div>
        </div>
    );
};

export default SlideShowSlide;



// WEBPACK FOOTER //
// ./src/components/pages/home/SlideShowSlide.tsx